import { For } from "solid-js";
import type { TodoStore } from "../lib/store";
import type { ViewKey } from "../lib/types";
import { todayKey } from "../lib/utils";
import { Icon } from "./Icon";

const views: Array<{ key: ViewKey; label: string; icon: "today" | "calendar" | "all" | "check" }> = [
  { key: "today", label: "Today", icon: "today" },
  { key: "upcoming", label: "Upcoming", icon: "calendar" },
  { key: "all", label: "All tasks", icon: "all" },
  { key: "completed", label: "Completed", icon: "check" },
];

export function ViewTabs(props: { store: TodoStore; onNavigate?: () => void }) {
  function countFor(view: ViewKey) {
    const active = props.store.tasks().filter((task) => !task.deleted_at);
    if (view === "today") return active.filter((task) => task.due_date === todayKey() && !task.completed).length;
    if (view === "upcoming") return active.filter((task) => task.due_date && task.due_date > todayKey() && !task.completed).length;
    if (view === "completed") return active.filter((task) => task.completed).length;
    return active.filter((task) => !task.completed).length;
  }

  return (
    <nav class="nav-stack" aria-label="Views">
      <For each={views}>
        {(item) => (
          <button
            class="nav-item"
            classList={{ active: !props.store.projectFilter() && props.store.view() === item.key }}
            aria-current={!props.store.projectFilter() && props.store.view() === item.key ? "page" : undefined}
            onClick={() => {
              props.store.setProjectFilter(null);
              props.store.setView(item.key);
              props.onNavigate?.();
            }}
          >
            <Icon name={item.icon} />
            <span>{item.label}</span>
            <span class="nav-count">{countFor(item.key)}</span>
          </button>
        )}
      </For>
    </nav>
  );
}
